import { useContext } from 'react';

import { Page } from '@rover/types';

import PageContext from './PageContext';

const usePageContext = (): Page => {
  const page = useContext(PageContext);
  if (!page) throw new Error('PageContext has no page defined');
  return page;
};

export default usePageContext;
